import { createSlice } from '@reduxjs/toolkit';

const { reducer, actions } = createSlice({
  name: 'dashboardReport',
  initialState: { data: null },
  reducers: {
    setData(state, action) { state.data = action.payload; },
  }
});

export { actions as dashboardReportActions };
export { reducer as dashboardReportReducer };
